import Vue from 'vue'
import VueI18n from 'vue-i18n'
import ru from '../i18n/ru'
import kg from '../i18n/kg'

Vue.use(VueI18n)

export default new VueI18n({
  locale: localStorage.lang ? localStorage.lang : 'ru',
  fallbackLocale: 'ru',
  messages: { ru, kg }
})
